// extracted by mini-css-extract-plugin
module.exports = {"icon":"StreamingServiceIcon_icon__5A81B"};